import React from 'react';
import PropTypes from 'prop-types';
import { connectCurrentRefinements } from 'react-instantsearch-dom';

const RefinementCount = ({ items }) => {
  const calculateRefinements = () => {
    if (items.length) {
      const advancedFilters = items.filter((item) => {
        return (
          item.attribute !== 'productType.title' &&
          item.attribute !== 'productFinish.finish.code' &&
          item.attribute !== 'collection.title.title'
        );
      });
      const refinements = advancedFilters.map(
        (item) => item.currentRefinement.length,
      );

      const sum = refinements.reduce((a, b) => a + b, 0);
      return `(${sum})`;
    }
    return null;
  };
  return <span className="md:hidden"> {calculateRefinements()}</span>;
};

RefinementCount.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
};

RefinementCount.defaultProps = {
  items: [],
};

export default connectCurrentRefinements(RefinementCount);
